
<small *ngIf="vm$ | async as vm">
    <span *ngIf="vm.lastUpdate.length">{{'ci.campaign.static.lastUpdate' | translate: {date: vm.lastUpdate} }}</span>
    <ng-container *ngIf="!vm.disableRedirection">
        {{'ci.common.realtimeRedirection1' | translate}}
        <a [queryParams]="vm.queryParams"
            [routerLink]="['/', 'insights', 'log-analyser']"
        >{{'ci.common.realtimeRedirection2' | translate}}</a>
    </ng-container>
</small>